import { nextivaApps } from 'lib/data';
import { PRODUCTS_REQUEST, PRODUCTS_SUCCESS, PRODUCTS_FAILURE } from './types';

const withNetworkDelay = (res) =>
  new Promise((resolve) => setTimeout(() => resolve(res), 300));

export const getProducts = (setSnackbar) => {
  return (dispatch) => {
    dispatch({ type: PRODUCTS_REQUEST });

    return withNetworkDelay(nextivaApps)
      .then((payload) => dispatch({ type: PRODUCTS_SUCCESS, payload }))
      .catch((error) => {
        setSnackbar({
          message: error.msg || 'Could not load products!',
          severity: 'error',
        });
        dispatch({ type: PRODUCTS_FAILURE, payload: error });
      });
  };
};
